module.exports = __webpack_public_path__ + "img/manage_nav_night.35b4a623.svg";